import {Injectable} from '@angular/core';
import {IdService} from "../id/id.service";

@Injectable()
export class OauthQuestionnaireGuardService  {

    constructor(
        private id: IdService
    ) {}

    canActivate() {
        if (this.id.loggedIn()) {
            return true;
        } else {
            this.assignUrl();
            return false;
        }
    }

    assignUrl() {
        location.assign(`/?retUrl=${location.href}`);
    }
}
